import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AddToShelfButtonContainer from '../../../../containers/AddToShelfButtonContainer';
import FormatIndicator from '@bibliocommons/format-indicator';
import BorrowingBibBrief from '../../shared/BorrowingBibBrief';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import { FormattedMessage } from 'react-intl';
import Rating from '@bibliocommons/rating';

import BibListItem from '../../../shared/BibListItem';

import './RecentlyReturnedItem.scss';

export default class RecentlyReturnedItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderBibActions',
      'renderSecondaryInfo',
      'renderBibBrief',
      'handleUpdateRating',
      'handleRemoveRating');
  }

  handleUpdateRating(rating) {
    if (this.props.rating) {
      return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
    }

    return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
  }

  handleRemoveRating() {
    return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.rating.get(0).get('id'));
  }

  renderRating() {
    const { item, ratingsTransactions, rating } = this.props;
    const currentUserRating = rating ? rating.get(0).get('rating') : null;
    const metadataId = item.get('metadataId');
    const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
    return (

      <div className="post-success-rating">
        <FormattedMessage id="label_rate_this" />
        <Rating
          id={`added_to_shelf_rating_${metadataId}`}
          isLoading={isLoading}
          rating={currentUserRating}
          handleButtonClick={this.handleUpdateRating}
          handleRemoveClick={this.handleRemoveRating} />
      </div>
    );
  }

  renderBibActions() {
    return (
      <div>
        { this.props.item && this.props.item.get('bib') &&
        <div className="recently-returned-shelf-button">
          <AddToShelfButtonContainer
            metadataId={this.props.item.get('metadataId')}
            workflowId={this.props.item.get('id')} />
        </div>
        }
      </div>
    );
  }

  renderSecondaryInfo() {
    const { item, defaultSort } = this.props;
    return (
      <div>
        <div className="returned-checkout-date">
          {defaultSort === 'checkedoutDate' && item.getIn(['checkedoutDate']) &&
          <div>
            <span className="info_label"><FormattedMessage id="checked_out_on" />: </span>
            <span className="text_black"><ShortFormattedDate value={item.getIn(['checkedoutDate'])} /></span>
          </div>
          }
          {defaultSort === 'returnedDate' && item.getIn(['returnedDate']) &&
          <div>
            <span className="info_label"><FormattedMessage id="returned_on" />: </span>
            <span className="text_black"><ShortFormattedDate value={item.getIn(['returnedDate'])} /></span>
          </div>
          }
        </div>
        <div>
          {this.renderBibActions()}
        </div>
      </div>
    );
  }

  renderBibBrief() {
    const { item } = this.props;
    if (item && item.getIn(['bib'])) {
      const briefInfo = item.getIn(['bib', 'briefInfo']);
      return (
        <BorrowingBibBrief bib={briefInfo}>
          <div>
            <FormatIndicator format={item.getIn(['bib', 'briefInfo', 'format'])} />
            {item.getIn(['bib', 'briefInfo', 'publicationDate']) &&
            <span> - {item.getIn(['bib', 'briefInfo', 'publicationDate'])}</span>
            }
          </div>
          {this.renderRating()}
        </BorrowingBibBrief>
      );
    }
    return '';
  }

  render() {
    const { item } = this.props;

    return (
      <BibListItem
        workflowId={item.get('id')}
        className="cp-recently-returned-item"
        bib={item.getIn(['bib', 'briefInfo'])}
        renderInfo={this.renderSecondaryInfo}
        renderBibBrief={() => this.renderBibBrief()} />
    );
  }
}

RecentlyReturnedItem.propTypes = {
  item: ImmutablePropTypes.map,
  defaultSort: PropTypes.string,
  ratingsTransactions:  ImmutablePropTypes.map,
  rating: ImmutablePropTypes.map,
  ratingsActions:  PropTypes.objectOf(PropTypes.func)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedItem/RecentlyReturnedItem.jsx